

export const InitialState = {
    workFlow: [],
    toggleSwitch: false,
    has_assigned_claims: false,
    loading: false,
    fieldList: [],
    roles: [],
    duplicate:{},
    validations:[],
    is_new_row_present:false,
    enableAuditing:false,
    notitify_message:{
        message:"",
        type:"success",
        show:false
    },
    deleteModalDetails:{
        show_modal:false,
        id:"",
        process_name:""
    },
    escalationSettings:{
        view_client_escalation_roles:[],
        initiate_client_escalation_roles:[],
    },
    escalationSettingsDuplicate:{
        view_client_escalation_roles:[],
        initiate_client_escalation_roles:[],
    },
    ArWorkflow:[],
}
